import { Button, FormControl, Stack, useColorModeValue, VStack } from "@chakra-ui/react";
import { InputLabel, Select, Title, TitleBar, Uploader, useModalView } from "components";
import { useIDType } from "hooks";
import { IStatefulUI } from "interfaces";
import { useMemo, useState } from "react";
import { FormState } from ".";

interface StepTwoProps extends IStatefulUI<FormState> {}

export function StepTwo(props: StepTwoProps) {
  const { state, set } = props;
  const { hasNext, onNext } = useModalView();

  const titleColor = useColorModeValue("primary.default", "secondary.400");

  const [file, setFile] = useState<File | null>(null);
  const ids = useIDType(state?.country ?? "nigeria");

  const handleFile = (files: File[]) => {
    setFile(files[0]);
    set({ identitficationFile: files[0] });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!file) return;
    onNext();
  };

  const isDisabled = useMemo(() => !state?.documentType || !file || !hasNext, [file, state, hasNext]);

  return (
    <Stack as="form" px="3px" onSubmit={handleSubmit}>
      <TitleBar mb="16px !important">
        <Title color={titleColor}>Government Identity Document</Title>
      </TitleBar>

      <FormControl mb="20px !important">
        <InputLabel>Select a Document type</InputLabel>
        <Select
          placeholder="Select Document"
          value={state?.documentType ?? ""}
          onChange={(e) => set({ documentType: e.target.value })}
        >
          {ids.map((id) => (
            <option key={id.value} value={id.value}>
              {id.name}
            </option>
          ))}
        </Select>
      </FormControl>

      {!!state?.documentType && <Uploader onFiles={handleFile} />}

      <VStack mt="40px !important">
        <Button minW={{ base: "auto", "2sm": "400px" }} w="100%" type="submit" isDisabled={isDisabled}>
          Next
        </Button>
      </VStack>
    </Stack>
  );
}
